export default "__VITE_ASSET__BMB1L5Yv__"